import { useTranslation } from "react-i18next";

import { Header } from "@datagame/ui";
import { StepProps } from "../Step1/Step1";
import { Step2 } from "../../RegistrationForm/Step2";

import styles from "../Step1/Step.module.scss";

export const ForgotPasswordStep2 = ({ changeStep }: StepProps) => {
  const { t } = useTranslation("account");

  return (
    <>
      <Header variant="h1" className={styles.header}>
        {t("forgotPassword.step2.header1")}{" "}
        <span className={styles.orangeText}>{t("forgotPassword.step2.header2")}</span>
      </Header>
      <Step2 changeStep={changeStep} />
    </>
  );
};
